/**
 * RunPort ブランド設定（ビルド時用）
 *
 * 用途: runport.html エントリポイントからビルド時に読み込まれる静的設定
 *
 * 注: ランタイムで動的にブランドを判断する場合は
 * frontend/src/config/brands.js の getBrandConfig() を使用
 */
export const brandConfig = {
  name: 'RunPort Desk',
  shortName: 'RunPort',
  tenantLabel: '大会',
  tenantCollection: 'races',
  tenantIdField: 'raceId',
};
